import React, { useState, useEffect } from 'react';
import './ArchivedEvents.css'; // Add styles for the Archived Events page
import { db } from '../firebase'; // Correct the import path
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';

function ArchivedEvents() {
  const [archivedEvents, setArchivedEvents] = useState([]);

  useEffect(() => {
    const fetchArchivedEvents = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'archivedEvents'));
        const archivedEventsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setArchivedEvents(archivedEventsData);
      } catch (error) {
        console.error('Error fetching archived events:', error);
      }
    };

    fetchArchivedEvents();
  }, []);

  const handleUnarchiveEvent = async (event) => {
    try {
      // Log the event ID for debugging
      console.log('Unarchiving event with ID:', event.id);
  
      // Add the event back to the "events" collection
      await addDoc(collection(db, 'events'), {
        eventName: event.eventName,
        eventLocation: event.eventLocation,
        createdBy: event.createdBy,
        games: event.games || [], // Include games if they exist
      });
  
      // Remove the event from the "archivedEvents" collection
      const archivedEventRef = doc(db, 'archivedEvents', event.id); // Correctly reference the document
      await deleteDoc(archivedEventRef); // Delete the document from Firestore
  
      // Update local state to remove the event from archivedEvents
      setArchivedEvents((prevArchivedEvents) =>
        prevArchivedEvents.filter((e) => e.id !== event.id)
      );
  
      alert('Event unarchived successfully!');
    } catch (error) {
      console.error('Error unarchiving event:', error);
      alert('Failed to unarchive the event.');
    }
  };

  return (
    <div className="archived-events-container">
      <h1>Archived Events</h1>
      {archivedEvents.length === 0 ? (
        <p className="juice">You currently have no archived events.</p>
      ) : (
        <ul className="archived-event-list">
          {archivedEvents.map((event) => (
            <li key={event.id} className="archived-event-item">
              <h2 className='event'>{event.eventName}</h2>
              <p>Location: {event.eventLocation}</p>
              <p>Created By: {event.createdBy}</p>
              <button
                onClick={() => handleUnarchiveEvent(event)}
                className="unarchive-button"
              >
                Unarchive Event
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ArchivedEvents;